import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field, FieldArray } from 'redux-form';
import ArrowUpBold from 'mdi-react/ArrowUpBoldIcon';
import ArrowDownBoldIcon from 'mdi-react/ArrowDownBoldIcon';
import TrashCanOutlineIcon from 'mdi-react/TrashCanOutlineIcon';
import renderField from '../../../shared/components/form/TextField';
import renderEditor from '../../../shared/components/tinymce/TinyMCE';
import RenderBilletValues from './RenderBilletValues';

class RenderBillet extends PureComponent {
  static moveToUp(fields, index) {
    if (index > 0) {
      fields.swap(index, index - 1);
    }
  }

  static moveToDown(fields, index) {
    if (fields.length - 1 !== index) {
      fields.swap(index, index + 1);
    }
  }

  static propTypes = {
    fields: PropTypes.objectOf(PropTypes.any).isRequired,
    meta: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  render() {
    const {
      fields,
      meta: { error, submitFailed },
    } = this.props;
    const { moveToUp, moveToDown } = RenderBillet;

    return (
      <div className="form__form-group">
        {fields.map((billet, index) => (
          <div key={index}>
            <div className="form__form-group">
              <span className="form__form-group-label">
                <strong>Кнопка # {index + 1}</strong>
              </span>
              <div className="form__form-group-field">
                <Field name={`${billet}.button`} component={renderField} type="text" placeholder="Название кнопки" />
                <div className="form__form-group-icon">
                  <ArrowUpBold onClick={() => moveToUp(fields, index)} />
                </div>
                <div className="form__form-group-icon">
                  <ArrowDownBoldIcon onClick={() => moveToDown(fields, index)} />
                </div>
                <div className="form__form-group-icon">
                  <TrashCanOutlineIcon onClick={() => fields.remove(index)} />
                </div>
              </div>
            </div>
            <div className="form__form-group-field">
              <FieldArray name={`${billet}.billet`} component={RenderBilletValues} />
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Контент # {index + 1}</span>
              <div className="form__form-group-field">
                <Field name={`${billet}.content`} component={renderEditor} />
              </div>
            </div>
          </div>
        ))}
        <ButtonToolbar className="form__button-toolbar wizard__toolbar">
          <Button color="primary" size="sm" onClick={() => fields.push({})}>
            Добавить материал
          </Button>
        </ButtonToolbar>
        {submitFailed && error && (
          <div className="form__form-group">
            <div>
              <span className="form__form-group-error">{error}</span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default RenderBillet;
